export default "__VITE_ASSET__DDoIL2Lw__"